import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {StoreItem, StoreItemDeleteInput, StoreItemFiltering, StoreItemInput} from './store-item.model';

export const StoreItemActions = createActionGroup({
  source: 'StoreItem/API',
  events: {
    'Load StoreItems': props<{ storeItems: StoreItem[], entity: string }>(),
    'Add StoreItem': props<{ storeItem: StoreItem }>(),
    'Upsert StoreItem': props<{ storeItem: StoreItem, entity: string }>(),
    'Add StoreItems': props<{ storeItems: StoreItem[] }>(),
    'Upsert StoreItems': props<{ storeItems: StoreItem[] }>(),
    'Update StoreItem': props<{ storeItem: Update<StoreItem> }>(),
    'Update StoreItems': props<{ storeItems: Update<StoreItem>[] }>(),
    'Delete StoreItem': props<{ id: string, entity: string }>(),
    'Delete StoreItems': props<{ ids: string[] }>(),
    'Clear StoreItems': emptyProps(),

    // Effects actions
    'CreateUpdateStoreItem': props<StoreItemInput>(),
    'removeStoreItem': props<StoreItemDeleteInput>(),
    'GetStoreItems':  props<StoreItemFiltering>(),
    'GetStoreItemsMergeMap':  props<StoreItemFiltering>(),
  }
});
